import { State } from '../../types';

export const texas: State = {
  name: 'Texas',
  abbreviation: 'TX',
  terms: [
    {
      word: 'Agave',
      phonetic: 'uh-GAH-vee',
      description: 'A common desert plant name in the Southwest. Often mispronounced as "uh-GAH-vay."'
    },
    {
      word: 'Amarillo',
      phonetic: 'am-uh-RILL-oh',
      // audioUrl: '/audio/amarillo.mp3',
      description: 'A city in the Texas Panhandle, pronounced with an anglicized ending rather than the Spanish "ah-mah-REE-yo."'
    },
    {
      word: 'Balmorhea',
      phonetic: 'bal-mor-AY',
      // audioUrl: '/audio/balmorhea.mp3',
      description: 'A town in West Texas, named by combining the names of its founders: Balcom, Morrow, and Rhea.'
    },
    {
      word: 'Bexar',
      phonetic: 'bear',
      // audioUrl: '/audio/bexar.mp3',
      description: 'A county in South Texas, pronounced as "bear," despite its Spanish origin.'
    },
    {
      word: 'Creosote',
      phonetic: 'KREE-uh-soht',
      description: 'The creosote bush, common in Southwestern deserts. Often mispronounced as "KREE-oh-soht."'
    },
    {
      word: 'Boerne',
      phonetic: 'BURN-ee',
      // audioUrl: '/audio/boerne.mp3',
      description: 'A city northwest of San Antonio, named after German author Ludwig Börne.'
    },
    {
      word: 'Gruene',
      phonetic: 'GREEN',
      // audioUrl: '/audio/gruene.mp3',
      description: 'A historic district in New Braunfels, with a German name meaning "green."'
    },
    {
      word: 'Killeen',
      phonetic: 'kuh-LEEN',
      // audioUrl: '/audio/killeen.mp3',
      description: 'A city in Central Texas, often mispronounced due to its double "L."'
    },
    {
      word: 'Llano',
      phonetic: 'LAN-oh',
      // audioUrl: '/audio/llano.mp3',
      description: 'A city and county in Central Texas, with a name meaning "plain" in Spanish.'
    },
    {
      word: 'Mexia',
      phonetic: 'muh-HAY-uh',
      // audioUrl: '/audio/mexia.mp3',
      description: 'A city in Limestone County, named after José Antonio Mexía.'
    },
    {
      word: 'Nacogdoches',
      phonetic: 'nak-uh-DOH-chess',
      // audioUrl: '/audio/nacogdoches.mp3',
      description: 'A city in East Texas, named after the Nacogdoche tribe of Caddo Indians.'
    },
    {
      word: 'Palestine',
      phonetic: 'PAL-es-teen',
      // audioUrl: '/audio/palestine.mp3',
      description: 'A city in East Texas, pronounced differently from the Middle Eastern region.'
    },
    {
      word: 'Refugio',
      phonetic: 're-FYOO-ree-oh',
      // audioUrl: '/audio/refugio.mp3',
      description: 'A town in South Texas, with a name meaning "refuge" in Spanish.'
    },
    {
      word: 'San Felipe',
      phonetic: 'san feh-LEE-pee',
      // audioUrl: '/audio/san_felipe.mp3',
      description: 'A town in Austin County, named after Stephen F. Austin\'s original colony.'
    },
    {
      word: 'Terlingua',
      phonetic: 'ter-LING-gwah',
      // audioUrl: '/audio/terlingua.mp3',
      description: 'A ghost town near Big Bend, known for its annual chili cook-off.'
    },
    {
      word: 'Waco',
      phonetic: 'WAY-koh',
      // audioUrl: '/audio/waco.mp3',
      description: 'City in central Texas'
    },
    {
      word: 'Waxahachie',
      phonetic: 'wok-suh-HATCH-ee',
      // audioUrl: '/audio/waxahachie.mp3',
      description: 'A city south of Dallas, with a name of Native American origin.'
    }
  ]
};